<template>
  <v-tabs>
    <v-tab
      v-for="tab_item in userTabs"
      :key="tab_item.FM_UUID"
      :to="tab_item.FM_PATH"
      class=" black--text"
    >
      <v-badge
        color="pink"
        :content="supportNewsCount"
        v-if="tab_item.FM_NAME === 'Поддержка' && supportNewsCount>0"
      >
        {{tab_item.FM_NAME}}
      </v-badge>
      <div v-else> {{tab_item.FM_NAME}} </div>
    </v-tab>
  </v-tabs>
</template>

<script>
// import { SYS_MODULES } from '@/store/actions/auth'
export default {
  name: 'systemNavTabs',
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    userTabs: {
      get: function () {
        const uTabs = this.$store.getters.getUserModules
        console.log('systemNavTabs getting user TABS', uTabs)
        return uTabs
      }
    },
    supportNewsCount: {
      get: function () {
        const sn = this.$store.getters.getClaimsLPData
        return sn.length
      }
    }
  }
}
</script>
